import { parse } from 'date-fns';
import { isValidDate } from './isValidDate';

const FORMATS = ['MM/dd/yy', 'M/dd/yy', 'M/dd', 'MM/dd', 'M/d', 'MM/d', 'MMddyyyy', 'MMddyy', 'MMdd', 'M'];
export const parseDate = (str: string, format: string, setToNoon: boolean): Date | null => {
  let parsedDate: Date | null = null;
  if (!str.length) {
    return null;
  }

  parsedDate = parse(str, format, new Date());

  if (!isValidDate(parsedDate)) {
    for (let i = 0; i < FORMATS.length; i++) {
      parsedDate = parse(str, FORMATS[i], new Date());
      if (isValidDate(parsedDate)) {
        break;
      }
    }

    if (!isValidDate(parsedDate)) {
      const newDate = new Date(str);
      parsedDate = isValidDate(newDate) ? newDate : parsedDate;
    }
  }

  parsedDate = setToNoon
    ? new Date(Date.UTC(parsedDate.getFullYear(), parsedDate.getMonth(), parsedDate.getDate(), 12, 0, 0, 0))
    : parsedDate;

  return parsedDate;
};
